// Lista de seções exibidas na loja.
// Para publicar uma versão nova, adicione um item na seção correspondente.
// tipo: "download" para arquivos em /public/apps, "redirect" para links externos (abre em nova aba).
const secoes = [
    {
        titulo: "Informações",
        itens: [
            { texto: "Status de Nossas Soluções", link: "https://uptime.contare.app/status/solucoes", tipo: "redirect" },
        ],
    },
    {
        titulo: "Youtube",
        itens: [
            { texto: "Contare Inventário", link: "https://www.youtube.com/playlist?list=PL1YQSb6WA6IiP3_LpsyoromkdeacTsSC_", tipo: "redirect" },
        ],
    },
    {
        titulo: "Agentes Windows",
        itens: [
            { texto: "Agente do Contare Bureau", link: "https://github.com/alanrigoni/agente-bureau-releases/releases/latest/download/AgenteBureau.exe", tipo: "redirect" },
            { texto: "Agente Leitor Fixo", link: "/apps/leitorfixo.zip", tipo: "download" },
            { texto: "Agente Leitor Fixo.exe", link: "https://leitor-fixo-windows-infra.s3.amazonaws.com/production/contare-leitor-fixo-installer.exe", tipo: "redirect" },
            { texto: "Agente Leitor Fixo R3", link: "/apps/leitorfixousbr3.zip", tipo: "download" },
            { texto: "Agente Leitor Fixo Zebra", link: "/apps/leitorfixozebra.zip", tipo: "download" },
            { texto: "Agente Leitor Fixo Hexapad", link: "/apps/leitorfixousbhexapad.zip", tipo: "download" },
            { texto: "Agente Leitor New", link: "https://github.com/alanrigoni/agente-leitor-fixo-releases/releases/latest/download/AgenteLeitorFixo.exe", tipo: "redirect" },
        ],
    },
    {
        titulo: "Apps",
        subsecoes: [
            {
                titulo: "Contare Factory",
                itens: [
                    { texto: "Contare Factory V1.26.03(APK)", link: "/apps/factory/1.26.03-prod.apk", tipo: "download" },
                    { texto: "Contare Factory V1.26.02(APK)", link: "/apps/factory/1.26.02-prod.apk", tipo: "download" },
                    { texto: "Contare Factory V1.26.01-05(APK)", link: "/apps/factory/1.26.01-05-prod.apk", tipo: "download" },
                    { texto: "Contare Factory V1.25.14(APK)", link: "/apps/factory/1.25.14-prod.apk", tipo: "download" },
                ],
            },
            {
                titulo: "Contare Factory (Homologação)",
                itens: [
                    { texto: "Contare Factory V1.26.03 HML(APK)", link: "/apps/factory/1.26.03-hml.apk", tipo: "download" },
                    { texto: "Contare Factory V1.26.02 HML(APK)", link: "/apps/factory/1.26.02-hml.apk", tipo: "download" },
                    { texto: "Contare Factory V1.26.01-04 HML(APK)", link: "/apps/factory/1.26.01-4-hml.apk", tipo: "download" },
                    { texto: "Contare Factory V1.25.09-3 HML(APK)", link: "/apps/factory/1.25.09-03-hml-sensormatic.apk", tipo: "download" },
                ],
            },
            {
                titulo: "Contare Geaimob",
                itens: [
                    { texto: "Contare Geaimob V1.2.4(APK)", link: "/apps/geaimob/geaimobv1.2.4.apk", tipo: "download" },
                ],
            },
            {
                titulo: "Contare Inventário",
                itens: [
                    { texto: "Contare Inventário V1.1.26-1 (APK)", link: "/apps/inventario/1.1.26-1-prod.apk", tipo: "download" },
                    { texto: "Contare Inventário V1.1.24-3 (APK)", link: "/apps/inventario/1.1.24-3-prod.apk", tipo: "download" },
                    { texto: "Contare Inventário V1.1.24-2 (APK)", link: "/apps/inventario/1.1.24-2-prod.apk", tipo: "download" },
                    { texto: "Contare Inventário V1.1.23-3 (APK)", link: "/apps/inventario/1.1.23-3.apk", tipo: "download" },
                    { texto: "Contare Inventário V1.1.23-2 New (APK)", link: "/apps/inventario/1.1.23-2-prod(1).apk", tipo: "download" },
                ],
            },
            {
                titulo: "ITRID",
                itens: [
                    { texto: "HUB 1.26.01", link: "/apps/itrid/1.26.01-itrid.apk", tipo: "download" },
                    { texto: "HUB 1.26.04 HML", link: "/apps/itrid/1.26.04-dev.apk", tipo: "download" },
                    { texto: "Ativos V1", link: "/apps/itrid/geaimob_v1.apk", tipo: "download" },
                ],
            },
            {
                titulo: "Experimental",
                itens: [
                    { texto: "Agente do Leitor Fixo (NEW)", link: "/apps/experimental/launcher1.0.1.exe", tipo: "download" },
                    { texto: "R6 Sem Corte (APK)", link: "/apps/experimental/1.26.01-04-prod-r6-sem-corte.apk", tipo: "download" },
                    { texto: "Agente Leitor Fixo R3 (CMD)", link: "/apps/demos/leitorfixousbr3.zip", tipo: "download" },
                    { texto: "Agente Leitor Fixo Hexapad (CMD)", link: "/apps/demos/leitorfixousbhexapad.zip", tipo: "download" },
                ],
            },
            {
                titulo: "Apps de Demonstrações",
                itens: [
                    { texto: "1.23-3 (APK)", link: "/apps/demos/1.23-3.apk", tipo: "download" },
                    { texto: "UHF R6 3 (APK)", link: "/apps/demos/UHF-ble3.apk", tipo: "download" },
                    { texto: "UHF R6 2 (APK)", link: "/apps/demos/UHF_BLE.apk", tipo: "download" },
                    { texto: "UHF R6 (APK)", link: "/apps/demos/R2_R6_Test.apk", tipo: "download" },
                    { texto: "UHF C72 (APK)", link: "/apps/demos/AppCenter_u_C7.apk", tipo: "download" },
                    { texto: "App Cód. Barra (APK)", link: "/apps/demos/codbarra.apk", tipo: "download" },
                ],
            },
        ],
    },
];

export default secoes;
